// window.SiteReady(($) => {
window.MapsReady(($) => {

  console.log('Init Block: Location Finder');

  function initMarker($marker, data) {
    let lat = $marker.data('lat');
    let lng = $marker.data('lng');
    let size = $marker.data('size');
    let state = $marker.data('state');
    let serviceOptions = $marker.data('options').toString();

    let latLng = {
      lat: parseFloat(lat),
      lng: parseFloat(lng)
    };

    let marker = new google.maps.Marker({
      position: latLng,
      map: data.map,
      icon: window.THEME_MAP_MARKER(size),
      $marker: $marker,
      state: state,
      serviceOptions: serviceOptions.split(','),
    });

    data.markers.push(marker);

    let content = $marker.html();

    if (content) {
      let infowindow = new google.maps.InfoWindow({
        content: '<div class="location_finder_infowindow">' + content + '</div>',
      });

      google.maps.event.addListener(marker, 'click', () => {
        if (data.infoWindow) {
          data.infoWindow.close();
        }

        infowindow.open(data.map, marker);
        data.infoWindow = infowindow;
      });
    }
  }

  function updateResults(data) {
    if (data.infoWindow) {
      data.infoWindow.close();
    }

    data.visible = [];
    data.markers.forEach((marker, index) => {
      // let copy = jQuery.extend(true, {}, marker);

      marker.show = true;

      if (data.selectedPlace) {
        marker.dist = google.maps.geometry.spherical.computeDistanceBetween(data.selectedPlace.geometry.location, marker.position);

        // dist /= 1000; // m to km
        // dist *= 0.6214; // km to miles

        if ( ((marker.dist / 1000) * 0.6214) > 40 ) {
          marker.show = false;
        }
      }

      if (data.selectedState) {
        if (marker.state.indexOf(data.selectedState) < 0) {
          marker.show = false;
        }
      }

      if (data.selectedOption) {
        if (marker.serviceOptions.indexOf(data.selectedOption) < 0) {
          marker.show = false;
        }
      }

      if (marker.show) {
        data.visible.push(marker);
      }
    });

    data.visible.sort((a, b) => {
      return a.dist - b.dist;
    });

    data.$container.html('');

    if (data.visible.length == 0) {
      data.$container.append( data.$empty.clone() );
    } else {
      data.visible.forEach((marker) => {
        data.$container.append( marker.$marker.clone() );
      });
    }

    data.$container.scrollTop(0);

    data.$count.html( data.visible.length );

    // window.history.replaceState({}, '', window.location.pathname + '?location=' + data.$input.val());
    window.history.replaceState({}, '', window.location.pathname + '?' + $.param({
      // location: data.$input.val(),
      state: data.$states.val(),
      option: data.$options.val(),
    }));

    centerMap(data);
  }

  function centerMap(data) {
    let bounds = new google.maps.LatLngBounds();
    let markers = data.visible;

    if (data.visible.length == 0) {
      markers = data.markers;
    }

    data.markers.forEach((marker) => {
      marker.setVisible(false);
    });

    markers.forEach((marker) => {
      marker.setVisible(true);

      bounds.extend({
        lat: marker.position.lat(),
        lng: marker.position.lng()
      });
    });

    if (data.visible.length == 1) {
      data.map.setCenter(bounds.getCenter());
    } else {
      data.map.fitBounds(bounds);
    }
  }

  //

  function onPlaceSelect(data) {
    console.log('Location Finder: Select Place');

    let places = data.input.getPlaces();

    if (places.length > 0) {
      data.selectedPlace = places[0];
    } else {
      data.selectedPlace = null;
    }

    updateResults(data);
  }

  function onOptionSelect(data) {
    console.log('Location Finder: Select Option');

    data.selectedOption = data.$options.val();

    updateResults(data);
  }

  function onStateSelect(data) {
    console.log('Location Finder: Select State');

    data.selectedState = data.$states.val();

    updateResults(data);
  }

  function onResetMap(data) {
    console.log('Location Finder: Reset map');

    data.$input.val('');
    data.$states.prop('selectedIndex', 0);
    data.$options.prop('selectedIndex', 0);

    data.selectedPlace = null;
    data.selectedState = null;
    data.selectedOption = null;

    updateResults(data);
  }

  //

  function init($el) {
    let data = {
      $el: $el,
      $map: $el.find('.js-location_finder_map'),
      $container: $el.find('.js-map_marker_container'),
      $markers: $el.find('.js-map_marker').detach(),
      $controls: $el.find('.js-location_finder_controls'),
      $input: $el.find('.js-location_finder_input'),
      $states: $el.find('.js-location_finder_states'),
      $options: $el.find('.js-location_finder_options'),
      $reset: $el.find('.js-location_finder_reset'),
      $empty: $el.find('.js-location_finder_empty').detach(),
      $count: $el.find('.js-location_finder_count'),
      markers: [],
      infoWindow: null,
      selectedPlace: null,
      selectedState: null,
      selectedOption: null,
    };

    //

    let mapOptions = {
      zoom: $el.data('zoom') || 12,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      // disableDefaultUI: true,
      streetViewControl: false,
      mapTypeControl: false,
      fullscreenControl: false,
      styles: window.THEME_MAP_STYLES,
    };

    data.map = new google.maps.Map(data.$map[0], mapOptions);
    data.input = new google.maps.places.SearchBox(data.$input[0]);

    //

    let params = new URLSearchParams(window.location.search);

    // if (params.get('location')) {
    //   data.$input.val(params.get('location'));

    //   let itemsLoaded = google.maps.event.addDomListener(document.body, 'DOMNodeInserted', (e) => {
    //     console.log('loaded', e.target.className);
    //     if (e.target.className == 'pac-container') {
    //       google.maps.event.removeListener(itemsLoaded);
    //       google.maps.event.trigger(data.input, 'keydown', { keyCode:40 });
    //       google.maps.event.trigger(data.input, 'keydown', { keyCode:13 });
    //       google.maps.event.trigger(data.input, 'focus');
    //       google.maps.event.trigger(data.input, 'keydown', { keyCode:13});
    //     }
    //   });
    // }

    if (params.get('state')) {
      data.$states.val(params.get('state')).change();
      data.selectedState = data.$states.val();
    }

    if (params.get('option')) {
      data.$options.val(params.get('option')).change();
      data.selectedOption = data.$options.val();
    }

    //

    data.$markers.each((index, el) => {
      initMarker($(el), data);
    });

    data.visible = data.markers.slice();

    centerMap(data);

    data.$controls.on('submit', (e) => {
      e.preventDefault();
      e.stopPropagation();
    });

    data.$reset.on('click', (e) => {
      onResetMap(data);
    });

    data.input.addListener('places_changed', () => {
      onPlaceSelect(data);
    });

    data.$states.on('change', (e) => {
      onStateSelect(data);
    });

    data.$options.on('change', (e) => {
      onOptionSelect(data);
    });

    updateResults(data);

    window.testinput = data.input;
    return data;
  }

  //

  $('.js-location_finder').each((index, el) => {
    let map = init($(el));
  });

});